import React from "react";
import { motion } from "framer-motion";
import classes from "./PrivacyPolicy.module.css";
import BackgroundWatchlist from "../Components/BackgroundWatchlist";
import { Link, useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <motion.div className={classes.modal}>
      <BackgroundWatchlist>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={() => navigate("/")}
          >
            <i className={`pi pi-arrow-left ${classes.close_icon}`} />
          </button>
        </div>

        <div className={classes.info_container}>
          <p className={classes.info}>
            {/* Privacy Policy */}
            ကိုယ်ရေးအချက်အလက်မူဝါဒ
          </p>
          <p className={classes.info_brief}>
            {/* Last Updated: 18-Nov-2024 */}
            နောက်ဆုံးမွမ်းမံမှု- 18-June-2025
          </p>
        </div>
      </BackgroundWatchlist>

      <div className={classes.privacy_content}>
        <section className={classes.section}>
          <p className={classes.p}>
            {/* This Privacy Policy describes how we collect, use, and protect your personal
            information when you use our entertainment website that provides
            details about movies and series, ratings, reviews, trailers, short
            clips, and includes a community feature where users can interact and
            share posts. */}

            ဤကိုယ်ရေးကိုယ်တာမူဝါဒတွင် ကျွန်ုပ်တို့သည် သင့်ကိုယ်ရေးကိုယ်တာကို စုဆောင်း၊ အသုံးပြုပုံနှင့် ကာကွယ်နည်းတို့ကို ဖော်ပြသည်။
            ကျွန်ုပ်တို့၏ ဖျော်ဖြေရေးဝဘ်ဆိုဒ်ကို သင်အသုံးပြုသည့်အခါ အချက်အလက်များကို ပံ့ပိုးပေးပါသည်။
            ရုပ်ရှင်များနှင့် ဇာတ်လမ်းတွဲများ၊ အဆင့်သတ်မှတ်ချက်များ၊ သုံးသပ်ချက်များ၊ နမူနာများ၊ တိုတိုများအကြောင်း အသေးစိတ်
            ကလစ်များနှင့် အသုံးပြုသူများ အပြန်အလှန် ဆက်သွယ်နိုင်သည့် အသိုင်းအဝိုင်း အင်္ဂါရပ်တစ်ခု ပါဝင်သည်။
            ပို့စ်များကိုမျှဝေပါ။
          </p>
          <p className={classes.p}>
            {/* By accessing or using this website or app, you agree to the terms
            of this Privacy Policy. If you do not agree, please do not use our
            website or app. */}
            ဤဝဘ်ဆိုဒ် သို့မဟုတ် အက်ပ်ကို ဝင်ရောက်အသုံးပြုခြင်းဖြင့် သို့မဟုတ် အသုံးပြုခြင်းဖြင့် သင်သည် စည်းမျဉ်းများကို သဘောတူပါသည်။
            ဤကိုယ်ရေးကိုယ်တာမူဝါဒ။ သင်သဘောမတူပါကကျွန်ုပ်တို့၏အသုံးမပြုပါနှင့်
            ဝဘ်ဆိုဒ် သို့မဟုတ် အက်ပ်။
          </p>
        </section>
        {/* <section className={classes.section}>
          <h2 className={classes.h2}>1. Information We Collect</h2>
          <h3 className={classes.h3}>1.1. Personal Information</h3>
          <p>When you create an account, we may collect:</p>
          <ul>
            <li>
              <strong>Username:</strong> Your chosen username for account
              creation and community interactions.
            </li>
            <li>
              <strong>Email Address:</strong> Used for account registration,
              login, and account-related notifications.
            </li>
            <li>
              <strong>Password:</strong> Used to protect your account.
            </li>
          </ul>
          <h3 className={classes.h3}>1.2. Usage Data</h3>
          <p className={classes.p}>
            We may collect information about how you use our website, including:
          </p>
          <ul>
            <li>
              <strong>Interactions:</strong> Posts, likes, comments, and other
              community interactions.
            </li>
          </ul>
          <h3 className={classes.h3}>1.3. Cookies and Tracking Technologies</h3>
          <p className={classes.p}>
            We use cookies and similar technologies to improve your experience
            on our website, remember your preferences, and analyze website
            traffic.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>2. How We Use Your Information</h2>
          <p className={classes.p}>
            We use the information we collect for the following purposes:
          </p>
          <ul>
            <li>
              <strong>Account Management:</strong> To create and manage your
              account.
            </li>
            <li>
              <strong>Content Personalization:</strong> To recommend movies,
              series, ratings, and reviews based on your interests.
            </li>
            <li>
              <strong>Community Interaction:</strong> To enable you to post,
              comment, like, and interact with other users in the community.
            </li>
            <li>
              <strong>Communication:</strong> To send you updates, newsletters,
              and promotional content (you may opt out of these communications).
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>3. Information Sharing and Disclosure</h2>
          <p className={classes.p}>
            We respect your privacy and will not share, sell, or rent your
            personal information to third parties without your consent, except
            in the following cases:
          </p>
          <ul>
            <li>
              <strong>Legal Requirements:</strong> We may disclose information
              if required by law or in response to legal proceedings, such as a
              court order or subpoena.
            </li>
            <li>
              <strong>Protection of Rights:</strong> We may disclose information
              if necessary to protect the rights, property, or safety of
              our users, or others.
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>4. Your Choices and Rights</h2>
          <ul>
            <li>
              <strong>Data Deletion:</strong> You may request the deletion of
              your account and personal information by visiting{" "}
              <Link to="/delete-account">Delete Account Page</Link>
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>5. Security of Your Information</h2>
          <p className={classes.p}>
            We take appropriate technical and organizational measures to protect
            your information from unauthorized access, loss, misuse, or
            alteration. However, no data transmission over the internet is
            entirely secure. Please protect your account by choosing a strong
            password and keeping it confidential.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>6. Children’s Privacy</h2>
          <p className={classes.p}>
            Our website is not intended for children under the age of 13, and we
            do not knowingly collect information from children. If you believe
            we have collected information from a child, please contact us
            immediately, and we will take appropriate action to remove the
            information.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>7. Changes to This Privacy Policy</h2>
          <p className={classes.p}>
            We may update this Privacy Policy periodically to reflect changes in
            our practices, legal requirements, or for other operational reasons.
            We will notify you of any significant changes by posting the new
            Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section> */}

        <section className={classes.section}>
          <h2 className={classes.h2}>၁။ ကျွန်ုပ်တို့ စုဆောင်းသည့် အချက်အလက်များ</h2>
          <h3 className={classes.h3}>၁.၁ ကိုယ်ပိုင်အချက်အလက်</h3>
          <p>အကောင့်တစ်ခုဖန်တီးသောအခါ၊ ကျွန်ုပ်တို့ စုဆောင်းနိုင်ပါသည် -</p>
          <ul>
            <li>
              <strong>အသုံးပြုသူအမည်:</strong> အကောင့်ဖန်တီးရန်နှင့် ကွန်မြူနിറ്റി အပြန်အလှန် ဆက်သွယ်မှုများအတွက် သင့်ရွေးချယ်သည့် အမည်။
            </li>
            <li>
              <strong>အီးမေးလ်လိပ်စာ:</strong> အကောင့် စာရင်းသွင်းခြင်း၊ ဝင်ရောက်ခြင်းနှင့် အကောင့်ပတ်သက်သည့် အကြောင်းကြားစာများအတွက် အသုံးပြုသည်။
            </li>
            <li>
              <strong>စကားဝှက်:</strong> သင့်အကောင့်ကို ကာကွယ်ရန် အသုံးပြုသည်။
            </li>
          </ul>
          <h3 className={classes.h3}>၁.၂ အသုံးပြုမှုဆိုင်ရာ အချက်အလက်</h3>
          <p className={classes.p}>
            ကျွန်ုပ်တို့၏ ဝဘ်ဆိုဒ်ကို သင်မည်သို့ အသုံးပြုသနည်း ဆိုသည့် အချက်အလက်များကို စုဆောင်းနိုင်ပါသည် -
          </p>
          <ul>
            <li>
              <strong>အပြန်အလှန်ဆက်သွယ်မှုများ:</strong> ပို့စ်များ၊ နှစ်သက်မှုများ၊ မှတ်ချက်များနှင့် အခြား ကွန်မြူနിറ്റി အပြန်အလှန်ဆက်သွယ်မှုများ။
            </li>
          </ul>
          <h3 className={classes.h3}>၁.၃ ကွတ်ကီးများနှင့် ခြေရာခံ နည်းပညာများ</h3>
          <p className={classes.p}>
            ကျွန်ုပ်တို့သည် သင့်အတွေ့အကြုံကို ကောင်းမွန်စေရန်၊ သင့် ဦးစားပေးရွေးချယ်မှုများကို မှတ်သားထားရန်နှင့်
            ဝဘ်ဆိုဒ် ယာဉ်ကြောဆက်ဆံမှုကို သုံးသပ်ရန် ကွတ်ကီးများနှင့် ဆင်တူနည်းပညာများကို အသုံးပြုသည်။
          </p>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>၂။ သင့်အချက်အလက်ကို ကျွန်ုပ်တို့ မည်သို့ အသုံးပြုသနည်း</h2>
          <p className={classes.p}>
            ကျွန်ုပ်တို့ စုဆောင်းသည့် အချက်အလက်များကို အောက်ပါ ရည်ရွယ်ချက်များအတွက် အသုံးပြုပါသည် -
          </p>
          <ul>
            <li>
              <strong>အကောင့်စီမံခန့်ခွဲမှု:</strong> သင့်အကောင့်ကို ဖန်တီးပြီး စီမံရန်။
            </li>
            <li>
              <strong>အကြောင်းအရာကို ကိုယ်ပိုင်အဆင်ပြေစေရန်:</strong> သင့်စိတ်ဝင်စားမှုအပေါ်အခြေခံပြီး ရုပ်ရှင်များ၊ ဇာတ်လမ်းများ၊ အဆင့်သတ်မှတ်မှုများနှင့် ပြန်လည်သုံးသပ်ချက်များကို အကြံပြုရန်။
            </li>
            <li>
              <strong>ကွန်မြူနിറ്റി အပြန်အလှန်:</strong> သင့်ကို ပို့စ်ရေးရန်၊ မှတ်ချက်ပေးရန်၊ နှစ်သက်ရန်နှင့် အခြားအသုံးပြုသူများနှင့် အပြန်အလှန်ဆက်သွယ်ရန်။
            </li>
            <li>
              <strong>ဆက်သွယ်မှု:</strong> သတင်းအပ်ဒိတ်များ၊ သတင်းလွှာများ၊ ပရိုမိုးရှင်း အကြောင်းအရာများကို ပေးပို့ရန် (ဤဆက်သွယ်မှုများမှ ထွက်နိုင်ပါသည်)။
            </li>
          </ul>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>၃။ အချက်အလက် မျှဝေခြင်းနှင့် ဖော်ထုတ်ခြင်း</h2>
          <p className={classes.p}>
            သင့်ကိုယ်ပိုင်အချက်အလက်ကို သင့်အပြန်အလှန် မလိုအပ်ဘဲ တတိယပတ်ကို မျှဝေ၊ မရောင်းချ၊ မငှားမည်ဟု အရိုအသေ ထိန်းသိမ်းပါမည်။
            သို့သော် အောက်ပါ အခြေအနေများတွင် မျှဝေသည့် အခွင့်ရှိပါသည် -
          </p>
          <ul>
            <li>
              <strong>ဥပဒေလိုအပ်ချက်များ:</strong> တရားရုံး အမိန့်များ သို့မဟုတ် တရားရေး အမိန့်များအရ ဖော်ထုတ်ရန် လိုအပ်ပါက။
            </li>
            <li>
              <strong>အခွင့်အရေးကာကွယ်မှု:</strong> အသုံးပြုသူများ သို့မဟုတ် အခြားသူများ၏ အခွင့်အရေး၊ ဂုဏ်သိက္ခာ၊ လုံခြုံမှုကို ကာကွယ်ရန် လိုအပ်ပါက။
            </li>
          </ul>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>၄။ သင့်ရွေးချယ်ခွင့်များနှင့် အခွင့်အရေးများ</h2>
          <ul>
            <li>
              <strong>အချက်အလက် ဖျက်ပစ်ခြင်း:</strong> သင့်အကောင့်နှင့် ကိုယ်ပိုင်အချက်အလက်ကို ဖျက်ရန် တောင်းဆိုနိုင်ပါသည် -
              <Link to="/delete-account">အကောင့်ဖျက်ရန် စာမျက်နှာ</Link>
            </li>
          </ul>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>၅။ သင့်အချက်အလက် လုံခြုံရေး</h2>
          <p className={classes.p}>
            ကျွန်ုပ်တို့သည် သင့်အချက်အလက်များကို ခွင့်မရှိသူများ ဝင်ရောက်မှု၊ လိုအပ်မည့်အသုံးချမှု၊ မတူညီသော အသုံးချမှုများမှ ကာကွယ်ရန်
            နည်းပညာပိုင်းနှင့် အဖွဲ့အစည်းပိုင်း အဆင့်အတန်းများကို အသုံးပြုပါသည်။ သို့သော် အင်တာနက်မှ တဆင့် အချက်အလက်ပို့ဆောင်မှုသည်
            အပြီးသတ် လုံခြုံမှု မရှိပါ။ ကျေးဇူးပြု၍ သင့်အကောင့်ကို ကာကွယ်ရန် စကားဝှက် ခိုင်ခံ့စွာ ရွေးချယ်ပြီး လျှို့ဝှက်ထားပါ။
          </p>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>၆။ ကလေးများ၏ လုံခြုံရေး</h2>
          <p className={classes.p}>
            ကျွန်ုပ်တို့၏ ဝဘ်ဆိုဒ်သည် အသက် ၁၃ နှစ်အောက် ကလေးများအတွက် မဟုတ်ပါ။ ကလေးများထံမှ အချက်အလက် မသိရှိဘဲ မစုဆောင်းပါ။
            ကလေးတစ်ဦးထံမှ အချက်အလက် မိမိတို့မှ စုဆောင်းခဲ့ကြောင်း ယုံကြည်ပါက ချက်ချင်း ဆက်သွယ်ပေးရန် တောင်းပန်အပ်ပါသည်။
            ထိုအချက်အလက်ကို ဖယ်ရှားရန် လိုအပ်သော အဆင့်များကို ချက်ချင်း လက်ခံဆောင်ရွက်မည်။
          </p>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>၇။ ဤ လုံခြုံရေးမူဝါဒ အပြောင်းအလဲများ</h2>
          <p className={classes.p}>
            ကျွန်ုပ်တို့သည် ဤ လုံခြုံရေးမူဝါဒကို အချိန်နှင့်အမျှ လေ့လာမှုများ၊ ဥပဒေလိုအပ်ချက်များ သို့မဟုတ် အခြား လုပ်ဆောင်မှုအကြောင်းရင်းများကြောင့်
            ပြောင်းလဲနိုင်ပါသည်။ အရေးကြီးသော ပြောင်းလဲမှုများကို ဤစာမျက်နှာတွင် အသစ်သော မူဝါဒကို တင်သွင်းပြီး "နောက်ဆုံး အပ်ဒိတ်"
            နေ့စွဲကို အသစ်ပြောင်းလဲ၍ သတင်းပေးပါမည်။
          </p>
        </section>


        {/* <section className={classes.section}>
          <h2 className={classes.h2}>8. Contact Us</h2>
          <p className={classes.p}>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or your personal information, please contact us at:
          </p>
          <p className={classes.p}>
            Email: info@visiontrek.in
            <br></br>
            Address: Phase 8 B, E 195, Phase 8B, Industrial Area, Sector 74,
            Sahibzada Ajit Singh Nagar, Punjab 160055
          </p>
        </section> */}
      </div>
    </motion.div>
  );
};

export default PrivacyPolicy;
